import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {AgendaCategory} from '../../../../../agenda/modules/category/api/entity/agendaCategory.model';
import {AgendaCategoryHolder} from '../../../../../agenda/modules/category/api/entity/agendaCategoryHolder';

export class ConsultationCategorySummaryModel implements SummaryModel, AgendaCategoryHolder {
    id: number;
    agendaCategory: AgendaCategory;
    expectedTurnover: number;
    partnerBookingStrategy: LovValueSummary;
    permissions: PermissionsModel;

    get active(): boolean {
        return this.agendaCategory.active;
    }
    get name(): string {
        return this.agendaCategory.summary.name;
    }
    get color(): string {
        return this.agendaCategory.summary.color;
    }
    get textColor(): string {
        return this.agendaCategory.summary.textColor;
    }
    get type(): LovValueSummary {
        return this.agendaCategory.type;
    }
    get duration(): number {
        return this.agendaCategory.duration;
    }

    get onlineBookingDescriptionNewPartner(): string {
        return this.agendaCategory.onlineBookingDescriptionNewPartner;
    }
    get onlineBookingDescriptionExistingPartner(): string {
        return this.agendaCategory.onlineBookingDescriptionExistingPartner;
    }
    get onlineBookingDisplayedPrice(): number {
        return this.agendaCategory.onlineBookingDisplayedPrice;
    }

    get onlineBookingInstructions(): string {
        return this.agendaCategory.onlineBookingInstructions;
    }

    get onlineBookingCancellationConditions(): string {
        return this.agendaCategory.onlineBookingCancellationConditions
    }
}

export enum ConsultationCategoryType {
    NOT_VISIT = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_NOT_VISIT',
    ANALYSE_POSTURALE_CYCLISTE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_ANALYSE_POSTURALE_CYCLISTE',
    ANALYSE_RUNNING = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_ANALYSE_RUNNING',
    BILAN_PODOLOGIQUE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_BILAN_PODOLOGIQUE',
    BILAN_POSTURAL = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_BILAN_POSTURAL',
    CONTROLE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_CONTROLE',
    REMISE_DE_SEMELLES = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_REMISE_DE_SEMELLES',
    RENOUVELLEMENT_DE_SEMELLES = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_RENOUVELLEMENT_DE_SEMELLES',
    ONGLE_INCARNÉ = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_ONGLE_INCARNÉ',
    ORTHONYXIE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_ORTHONYXIE',
    ORTHOPLASTIE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_ORTHOPLASTIE',
    SOINS_DE_PÉDICURIE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_SOINS_DE_PÉDICURIE',
    SOINS_DIABÉTIQUES = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_SOINS_DIABÉTIQUES',
    SOINS_POD = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_SOINS_POD',
    SOINS_À_DOMICILE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_SOINS_À_DOMICILE',
    TRAITEMENT_DE_VERRUE_PLANTAIRE = 'AGENDA_CATEGORY_MEDICAL_PODIATRIST_TRAITEMENT_DE_VERRUE_PLANTAIRE',
}
